import {map, take} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../../shared/api.service';

@Injectable()
export class IOService {

  constructor(private http: HttpClient,
              private apiService: ApiService) {}

  public getIOs(filter: any) : Observable<any> {
    return this.http.get(this.apiService.getIOs()).pipe(take(1),map(value => {
      return value;
    }),);
  }

  public filterIOs(filter: any) : Observable<any> {
    return this.http.post(this.apiService.filterIOs(), {...filter}).pipe(take(1),map(value => {
      return value;
    }),);
  }

  public deleteIO(id: string) : Observable<any> {
    return this.http.delete(this.apiService.deleteIO(id)).pipe(take(1),map(value => {
      return value;
    }),);
  }
}
